export default __webpack_public_path__ + "a1efab72cc4a8771fe8fdd0e26c840f1.png";